/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actiondailylimiterror3Inputs */

const en_actiondailylimiterror3 = /** @type {(inputs: Actiondailylimiterror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This place already sent an action today. The next one is possible tomorrow.`)
};

const de_actiondailylimiterror3 = /** @type {(inputs: Actiondailylimiterror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für diesen Ort ist heute schon eine Aktion geschaltet. Die nächste geht ab morgen.`)
};

/**
* | output |
* | --- |
* | "This place already sent an action today. The next one is possible tomorrow." |
*
* @param {Actiondailylimiterror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actiondailylimiterror3 = /** @type {((inputs?: Actiondailylimiterror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actiondailylimiterror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actiondailylimiterror3(inputs)
	return de_actiondailylimiterror3(inputs)
});
export { actiondailylimiterror3 as "actionDailyLimitError" }